export const MYFARM_URL =
  process.env.REACT_APP_MYFARM_URL || 'https://myfarm-dev.frontierag.co.uk/';

export const IS_AUTH_ENABLED = process.env.REACT_APP_IS_AUTH_ENABLED === 'true';
export const APP_SERVER_URL = process.env.REACT_APP_SERVER_URL || `${window.location.origin}/api`;
export const REDIRECT_TIMER_COUNT = 10;

export const domain = process.env.VITE_AUTH0_DOMAIN!;
export const clientId = process.env.VITE_AUTH0_CLIENT_ID!;
export const audience = process.env.VITE_AUTH0_AUDIENCE;
export const redirectUri =
  process.env.VITE_AUTH0_CALLBACK_URL || `${window.location.origin}/callback`;
export const scope = 'openid profile email';
export const auth0CacheLocation = (process.env.REACT_APP_AUTH0_CACHE_LOCATION || 'memory') as
  | 'memory'
  | 'localstorage';
